import { useState } from "react";
import { ISVG } from "./UrlIcon";

export interface ISettingsFillIconProps extends ISVG {
    hoverColor?: string;
}

const DEFAULT_FILL = "white";

export const SettingsFillIcon = ({ fill, hoverColor }: ISettingsFillIconProps) => {
    const [_fill, set_fill] = useState(fill ?? DEFAULT_FILL);

    return (
        <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onMouseEnter={() => {
                set_fill(hoverColor ?? _fill);
            }}
            onMouseLeave={() => {
                set_fill(fill ?? DEFAULT_FILL);
            }}
        >
            <g filter="url(#filter0_d_1376_5164)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.2352 4.75507C18.6651 2.41498 15.335 2.41498 14.765 4.75507C14.6799 5.1067 14.513 5.43328 14.2778 5.70822C14.0427 5.98316 13.7459 6.19869 13.4117 6.33728C13.0775 6.47587 12.7153 6.5336 12.3546 6.50577C11.9939 6.47794 11.6448 6.36533 11.3359 6.17712C9.27779 4.92307 6.9227 7.27816 8.17675 9.33624C8.98678 10.6653 8.26825 12.3994 6.75619 12.7669C4.4146 13.3354 4.4146 16.667 6.75619 17.234C7.10792 17.3193 7.43456 17.4863 7.7095 17.7217C7.98443 17.957 8.1999 18.254 8.33836 18.5883C8.47682 18.9227 8.53435 19.285 8.50626 19.6459C8.47818 20.0067 8.36528 20.3558 8.17675 20.6647C6.9227 22.7228 9.27779 25.0778 11.3359 23.8238C11.6448 23.6353 11.9939 23.5224 12.3547 23.4943C12.7155 23.4662 13.0778 23.5237 13.4122 23.6622C13.7466 23.8006 14.0435 24.0161 14.2789 24.291C14.5142 24.566 14.6813 24.8926 14.7665 25.2444C15.335 27.5859 18.6666 27.5859 19.2337 25.2444C19.3192 24.8928 19.4864 24.5664 19.7218 24.2916C19.9572 24.0169 20.2541 23.8016 20.5884 23.6631C20.9226 23.5247 21.2848 23.4671 21.6456 23.4951C22.0063 23.523 22.3553 23.6356 22.6643 23.8238C24.7224 25.0778 27.0775 22.7228 25.8234 20.6647C25.6352 20.3557 25.5226 20.0066 25.4947 19.6459C25.4668 19.2852 25.5244 18.923 25.6628 18.5887C25.8012 18.2545 26.0165 17.9576 26.2913 17.7222C26.566 17.4868 26.8924 17.3195 27.244 17.234C29.5856 16.6655 29.5856 13.3339 27.244 12.7669C26.8922 12.6817 26.5656 12.5146 26.2907 12.2792C26.0157 12.0439 25.8003 11.747 25.6618 11.4126C25.5233 11.0782 25.4658 10.7159 25.4939 10.3551C25.522 9.99425 25.6349 9.64516 25.8234 9.33624C27.0775 7.27816 24.7224 4.92307 22.6643 6.17712C22.3554 6.36565 22.0063 6.47855 21.6455 6.50664C21.2847 6.53472 20.9223 6.47719 20.588 6.33874C20.2536 6.20028 19.9566 5.98481 19.7213 5.70987C19.486 5.43493 19.3189 5.1083 19.2337 4.75657L19.2352 4.75507ZM17.0001 19.5006C18.1936 19.5006 19.3382 19.0265 20.1822 18.1826C21.0261 17.3386 21.5003 16.194 21.5003 15.0005C21.5003 13.8069 21.0261 12.6623 20.1822 11.8184C19.3382 10.9744 18.1936 10.5003 17.0001 10.5003C15.8066 10.5003 14.6619 10.9744 13.818 11.8184C12.974 12.6623 12.4999 13.8069 12.4999 15.0005C12.4999 16.194 12.974 17.3386 13.818 18.1826C14.6619 19.0265 15.8066 19.5006 17.0001 19.5006Z"
                    fill={_fill}
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_1376_5164"
                    x="0"
                    y="0"
                    width="34"
                    height="34.001"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="2.5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1376_5164" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1376_5164" result="shape" />
                </filter>
            </defs>
        </svg>
    );
};
